import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { format, isValid } from 'date-fns';
import { ORDER_DATE_FORMAT } from '../../../utils/constants';
import { hasSameExpirationDate } from '..';
import MastercodeExpirationList from './MastercodeExpirationList';

export type Props = {
  activationDate: Date | null;
  expirationDates: { code: string; date: Date }[];
};

const ActivationWarningText = ({ activationDate, expirationDates }: Props) => {
  const { t } = useTranslation('Order');

  if (!isValid(activationDate)) return null;

  if (expirationDates.length > 0 && hasSameExpirationDate(expirationDates)) {
    return (
      <Box>
        {t('expireDateWarning', {
          activateDate: format(activationDate!, ORDER_DATE_FORMAT),
          expireDate: format(expirationDates[0].date, ORDER_DATE_FORMAT)
        })}
      </Box>
    );
  }

  return (
    <Box>
      {t('expireDatesWarning', { activateDate: format(activationDate!, ORDER_DATE_FORMAT) })}
      <MastercodeExpirationList expirationDates={expirationDates} />
    </Box>
  );
};

export default ActivationWarningText;
